import React from 'react';

export const LoadingSkeleton = () => (
    <div className="bg-white dark:bg-slate-800 rounded-xl p-4 sm:p-5 md:p-6 shadow-sm border border-slate-100 dark:border-slate-700 animate-pulse space-y-4">
        <div className="h-4 bg-slate-200 dark:bg-slate-700 rounded w-3/4"></div>
        <div className="flex gap-2">
            <div className="h-3 bg-slate-200 dark:bg-slate-700 rounded w-20"></div>
            <div className="h-3 bg-slate-200 dark:bg-slate-700 rounded w-20"></div>
        </div>
        <div className="space-y-2 pt-2">
            <div className="h-3 bg-slate-200 dark:bg-slate-700 rounded w-full"></div>
            <div className="h-3 bg-slate-200 dark:bg-slate-700 rounded w-full"></div>
            <div className="h-3 bg-slate-200 dark:bg-slate-700 rounded w-2/3"></div>
        </div>
    </div>
);
